import { Palette } from "@mui/material";
import { keyframes } from "@mui/material";

export const wave = keyframes`
  0%, 100% { transform: scaleY(0.25); }
  50% { transform: scaleY(1); }
`;

export const dictationContainerSx = {
  flex: 1,
  width: "100%",
  py: 2,
};

export const transcriptTextSx = (palette: Palette, hasTranscript: boolean) => ({
  color: hasTranscript ? palette.text.primary : palette.text.heading,
  fontSize: 14,
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  minHeight: 20,
});

export const recordingDotSx = (palette: Palette, isPaused: boolean) => ({
  width: 8,
  height: 8,
  borderRadius: "50%",
  backgroundColor: isPaused ? palette.text.disabled : palette.error.dark,
});

export const elapsedTimeSx = (palette: Palette) => ({
  fontFamily: "ui-monospace, Menlo, monospace",
  color: palette.text.heading,
});

export const barSx = (
  palette: Palette,
  isPaused: boolean,
  height: number,
  delayMs: number,
) => ({
  flex: 1,
  minWidth: 2,
  maxWidth: 4,
  height: `${height}px`,
  borderRadius: 999,
  backgroundColor: isPaused ? palette.text.disabled : palette.primary.main,
  animation: `${wave} 1.1s ease-in-out infinite`,
  animationPlayState: isPaused ? "paused" : "running",
  animationDelay: `${delayMs}ms`,
});

export const pauseButtonSx = (palette: Palette) => ({
  flexShrink: 0,
  border: `1px solid ${palette.text.borderLine}`,
});

export const cancelButtonSx = (palette: Palette) => ({
  flexShrink: 0,
  border: `1px solid ${palette.error.main}`,
  backgroundColor: palette.error.lighter,
});

export const confirmButtonSx = (palette: Palette) => ({
  flexShrink: 0,
  backgroundColor: palette.primary.main,
  "&:hover": { backgroundColor: palette.primary.dark },
});
